import { colors, FelaCSS, FelaCSSWithCustomSelectors, spacing } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  title: FelaCSS;
  slide: FelaCSSWithCustomSelectors;
}

const styles = (): IStyles => ({
  wrapper: {
    paddingVertical: spacing[3],
    marginBottom: spacing[8],

    maxWidthTabletSm: {
      marginLeft: spacing[4],
    },
  },
  title: {
    color: colors.space,
    fontDefaultSemiBold: 24,
    lineHeight: '120%',
    cursor: 'default',
    margin: 0,

    maxWidthTabletSm: {
      fontDefaultSemiBold: 16,
    },
  },
  slide: {
    maxWidthTabletSm: {
      paddingRight: spacing[3],
    },
  },
});

export default styles;
